export const SET_MEMBER_GENERAL_INFORMATION = 'SET_MEMBER_GENERAL_INFORMATION';
export const SET_MEMBER_PROFILE_DATA = 'SET_MEMBER_PROFILE_DATA'
export const SET_COMPANY_DATA = 'SET_COMPANY_DATA';
export const SET_LOCATIONS_OF_MEMBER = 'SET_MEMBER_LOCATIONS';
export const ADD_SCHOOL_DATA = 'ADD_SCHOOL_DATA';
export const EDIT_COMPANY_DATA = 'EDIT_COMPANY_DATA';
export const EDIT_SCHOOL_DATA = 'EDIT_SCHOOL_DATA';
export const ADD_COMPANY_DATA = 'ADD_COMPANY_DATA';
export const ADD_PHILANTHROPY_DATA = 'ADD_PHILANTHROPY_DATA';
export const SET_PHILANTHROPY_DATA = 'SET_PHILANTHROPY_DATA';
export const DELETE_COMPANY_DATA = 'DELETE_COMPANY_DATA';
export const DELETE_SCHOOL_DATA = 'DELETE_SCHOOL_DATA';
export const DELETE_PHILANTHROPY_DATA = 'DELETE_PHILANTHROPY_DATA';
export const SET_MEMBER_NETWORK = 'SET_MEMBER_NETWORK';
export const SET_COMPANY_NETWORK = 'SET_COMPANY_NETWORK';
export const SET_SCHOOL_NETWORK = 'SET_SCHOOL_NETWORK';
export const SET_NONPROFIT_NETWORK = 'SET_NONPROFIT_NETWORK';
export const SET_KEY = 'SET_KEY';
export const SET_CAUSES_DATA = 'SET_CAUSES_DATA';
export const SET_MEMBER_CURRENT_LOCATION = 'SET_MEMBER_CURRENT_LOCATION';
export const SET_MEMBER_LOCATIONS = 'SET_MEMBER_LOCATIONS';
export const SET_MEMBER_METROPOLITAN_AREAS = 'SET_MEMBER_METROPOLITAN_AREAS';
export const SET_METROPOLITAN_AREAS = 'SET_METROPOLITAN_AREAS';
export const SET_SUBTYPE_OPPORTUNITIES_LIST = 'SET_SUBTYPE_OPPORTUNITIES_LIST';

export const SET_FUNNEL_LIST = 'SET_FUNNEL_LIST';
export const SET_EVENT_TYPES = 'SET_EVENT_TYPES';
export const GET_SHORTLISTED_OPPORTUNITY = 'GET_SHORTLISTED_OPPORTUNITY';



// WEBPACK FOOTER //
// ./static-content/private/javascripts/store/modules/member/mutation-types.ts